import { render, staticRenderFns } from "./IcEraser.vue?vue&type=template&id=6ec02b24&scoped=true"
import script from "./IcEraser.vue?vue&type=script&lang=js"
export * from "./IcEraser.vue?vue&type=script&lang=js"
import style0 from "./IcEraser.vue?vue&type=style&index=0&id=6ec02b24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec02b24",
  null
  
)

export default component.exports